import React, {useMemo, useRef, useState} from 'react';
import {Template} from "../../../../../../components/template/template.jsx";
import aggridUtils from "../../../../../../utils/aggrid-utils.js";
import {AgGridReact} from "ag-grid-react";
import {Card} from "../../../../../../components/card/card.jsx";
import {useQuery} from "@tanstack/react-query";
import sosService from "../../../../../../services/web/sos-service.js";
import projectUtils from "../../../../../../utils/project-utils.js";
import {navigateHook} from "../../../../../../hooks/use-navigate.js";

const SosOpenList = () => {
    const navigate = navigateHook();

    const {data} = useQuery({
        queryFn: () => sosService.listOpen(),
        queryKey: ["list"],
        refetchInterval: 5000
    })

    const gridRef = useRef(undefined);

    const [columnDefs, ] = useState([
        {headerName: "Nome/Razão Social", field: "citizen.name"},
        {headerName: "Proteção", field: "citizen.protectionPrograms"},
        {headerName: "Acionamento", field: "dtStart",
            comparator: (a, b, nodeA, nodeB, isInverted) => {
                return aggridUtils.nullLastComparator(a, b, nodeA, nodeB, isInverted);
            }
        },
        {headerName: "Assumido", field: "dtAck",
            comparator: (a, b, nodeA, nodeB, isInverted) => {
                return aggridUtils.nullLastComparator(a, b, nodeA, nodeB, isInverted);
            }
        },
        {headerName: "Telefone", field: "citizen.phone", valueFormatter: ({value}) => projectUtils.formatPhone(value)}
    ]);

    const autoSizeStrategy = useMemo(
        () => ({
            type: "fitGridWidth",
        }), []
    );

    const theme = useMemo(() => {
        return aggridUtils.generalTheme();
    }, []);

    const onCellClicked = ({event, data}) => {
        const isBlank = event.ctrlKey;
        navigate(`/sos/event-open/${data.id}`, isBlank);
    }

    return (
        <Template>
            <Template.Header>
                <Template.Title>SOS em aberto</Template.Title>
            </Template.Header>

            <Template.Body>
                <Card>
                    <Card.Body>
                        <div className={"h-[calc(100vh-91px)] aggrid-row-pointer"}>
                            <AgGridReact
                                ref={gridRef}
                                rowHeight={35}
                                rowData={data ?? []}
                                columnDefs={columnDefs}
                                autoSizeStrategy={autoSizeStrategy}
                                animateRows={false}
                                suppressCellFocus={true}
                                onCellClicked={onCellClicked}
                                gridOptions={{localeText: aggridUtils.localization()}}
                                theme={theme}
                            />
                        </div>
                    </Card.Body>
                </Card>
            </Template.Body>
        </Template>
    );
};

export default SosOpenList;
